import { baseApi } from './base';
import { JobTitle } from '../../types/interfaces';

export const getJobTitles = async () => {
  const response = await baseApi.get<JobTitle[]>(`/v1/public/job-title`);

  return response.data;
};
